module.exports = __webpack_public_path__ + "img/apple_pick_hand_hold_q90_lossy.30670a37.webp";